<template>
   <div class="general-active-section" :class="validatedSectionClass">
    <div class="row " >
      <div class="col-md-offset-1 col-md-10" >
        <div class="form-group">
          <form @submit.prevent="validate(true)">
            <label class="control-label required" for="site-code-results"
                    v-html="computeCaption(fields_en['office_location_code'], $store.state.lang.value.toLowerCase())">
            </label>
            <div>
              <small class="text-danger" v-if="verbiage">
                *{{ verbiage && computeCaption(verbiage, $store.state.lang.value.toLowerCase()) }}
              </small>
            </div>
            <input class="form-control"
                    data-vv-as="Site Code"
                    id="site-code-results"
                    type="text"
                    name="siteCode"
                    v-validate="modelValidations.siteCode"
                    v-model="model.siteCode"
                    placeholder="ex: 12345678"
                   onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
            />
          </form>
          <small class="text-danger" v-show="siteCode.invalid">
           {{getError('siteCode') && computeCaption(getError('siteCode'), $store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>
      </div>
    <div class="col-md-2 pl-0">
      <language-button id="mobile-language"></language-button>
    </div>
  </div>
</template>

<script>
  import {mapFields} from 'vee-validate'
  import LanguageButton from '../../LanguageButton'
  import axios from 'axios'
  import {TranslationsUtils} from '../../../../../utils/Translations'
  import {SettingsUtils} from '../../../../../utils/SiteConfigurations'
  export default {
    components: {
      LanguageButton
    },
    mixins: [TranslationsUtils, SettingsUtils],
    data () {
      return {
        validatedSectionClass: '',
        fields_en: {
          office_location_code: 'Office Location Code'
        },
        model: {
          siteCode: null
        },
        modelValidations: {
          siteCode: {
            min: 2,
            required: true
          }
        }
      }
    },
    mounted () {
      if (this.$route.query.site_code) {
        this.model.siteCode = this.$route.query.site_code
        this.validate(true)
      }
      if (this.$route.query.confirmation_number) {
        this.$store.state.confirmationNumberResultsUrl = this.$route.query.confirmation_number
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      jumpToTheNextPage () {
        this.$emit('jumpToTheNextPage')
      },
      validate (nextPage) {
        if (this.model.siteCode && this.model.siteCode.length >= 2) {
          return new Promise((resolve, reject) => {
            this.model.validatedSiteCode = null
            let one = process.env.SERVER_URI + '/validate/site/' + this.model.siteCode
            let two = process.env.SERVER_URI + '/validate/site/results/' + this.model.siteCode
            const requestOne = axios.get(one)
            const requestTwo = axios.get(two)
            axios.all([requestOne, requestTwo])
              .then(axios.spread((...responses) => {
                if (responses[0].data === false) {
                  this.$validator.errors.add({field: 'siteCode', msg: 'Invalid Code!'})
                  let field = this.$validator._resolveField('siteCode')
                  field.setFlags({invalid: true})
                  document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
                  reject(new Error('Invalid site code!!'))
                } else {
                  this.overwriteGraphSettings(responses[0].data)
                }
                if (responses[1].data === false) {
                  this.$validator.errors.add({field: 'siteCode', msg: 'Invalid Code!'})
                  let field = this.$validator._resolveField('siteCode')
                  field.setFlags({invalid: true})
                  document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
                  reject(new Error('Invalid Office Location Code!!'))
                } else {
                  if (responses[1].data['logo']) {
                    this.$store.state.logo = responses[1].data['logo']
                  }
                  this.$store.state.results.site = responses[1].data
                  if (nextPage) {
                    this.jumpToTheNextPage()
                  }
                }
                resolve(true)
              })).catch(errors => {
                console.log('Error' + errors)
              })
          })
        } else {
          this.$validator.errors.add({field: 'siteCode', msg: 'Office Location Code is required!'})
          let field = this.$validator._resolveField('siteCode')
          field.setFlags({invalid: true})
          document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
          return false
        }
      }
    },
    computed: {
      verbiage () {
        return this.$store.state.configs.OFFICE_LOCATION_VERBIAGE
      },
      ...mapFields(['siteCode'])
    },
    watch: {
      'model.siteCode': {
        handler: function (after, before) {
          if (this.model.siteCode.length > this.modelValidations.siteCode.min - 1) {
            this.validatedSectionClass = 'validated-section-class'
          } else {
            this.validatedSectionClass = 'invalid-section-class'
          }
        }
      }
    }
  }
</script>

<style scoped>

  #site-code-results{
    text-transform: uppercase;
  }

  >>> .language{
    margin: 0px !important;
    margin-top: 10px !important;
  }

  @media (max-width: 992px){
    #mobile-language{
      display: none;
    }
  }

  .pl-0{
    padding-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Results/Wizard/SiteSelectionStep.vue